import { Domains, DOMAIN_KEY } from '../../constants';
import { DefaultLocalStorageService } from '../local-storage-service';

export const LocalStorageDomainService =
  new DefaultLocalStorageService<Domains>(DOMAIN_KEY);
